import React, { useState } from "react"
import { HARISENIN_LOGO, HARISENIN_PUBLIC_PAGE_ASSETS } from "@const/pictures"
import { FlexBox } from "@components/wrapper"
import { MdLocationPin } from "react-icons/md"
import { LinkButton, RegularButton } from "@components/button"
import { GiShare } from "react-icons/gi"
import { GoClock } from "react-icons/go"

import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"
import { ModalShare } from "@modules/career-detail/components/ModalShare"
import clsx from "clsx"
import Image from "next/image"

interface DetailBannerProps {
  position_name: string | any
  job_type: string
  job_system: string
  job_expired_at: string
  created_at: string
  category_id: number
  career_position_id: number
}

export function DetailBanner({
  created_at,
  job_expired_at,
  position_name,
  job_system,
  job_type,
  career_position_id,
  category_id,
}: DetailBannerProps) {
  const [modalShare, setModalShare] = useState(false)

  dayjs.extend(relativeTime)

  return (
    <section>
      <div className="relative sm:mb-[9vw] mb-[15vw]">
        <Image
          alt="cover"
          src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/career-detail_banner.png`}
          className="w-full object-cover sm:h-[24vw] h-[30vw] rounded"
          width={1440}
          height={400}
        />

        <FlexBox
          className={clsx(
            "sm:w-[14vw] sm:h-[14vw] px-2.5 bg-primary-grey border-6 border-white rounded absolute sm:-bottom-[7vw] sm:left-[calc(50%-7vw)]",
            "w-[24vw] h-[24vw] -bottom-[12vw] left-[calc(50%-12vw)]"
          )}
          align="center"
          justify="center"
        >
          <Image
            src={HARISENIN_LOGO}
            alt="harisenin.com logo"
            className="w-full"
            height={50}
            width={200}
          />
        </FlexBox>
      </div>

      <div className="pb-10 border-b border-grey-90">
        <div className="sm:mb-[50px] mb-10">
          <h1
            className={clsx(
              "text-dark-green font-semibold sm:text-2.5xl text-center sm:mb-4",
              "text-md mb-3"
            )}
          >
            {position_name} - {job_type}
          </h1>

          <FlexBox className="mx-auto w-fit sm:gap-4 gap-3" align="center">
            <FlexBox align="center" className="sm:gap-3 gap-2">
              <MdLocationPin className="text-blue sm:text-lg" />
              <div className="sm:text-md text-sm font-medium">{job_system}</div>
            </FlexBox>

            <div className="font-semibold leading-0 text-primary-blue">{job_type}</div>
          </FlexBox>
        </div>

        <FlexBox className={clsx("sm:justify-between sm:flex-row sm:gap-0", "flex-col gap-4")}>
          <LinkButton
            href={`/form/apply?career_position_id=${career_position_id}&category_id=${category_id}&position_name=${position_name}`}
            className="uppercase sm:w-1/4 w-full"
            customPadding="sm:py-3 py-2.5"
            variant="blue"
          >
            LAMAR SEKARANG
          </LinkButton>
          <RegularButton
            className="sm:w-1/4 w-full"
            customPadding="sm:py-3 py-2.5"
            variant="transparent-black"
            textClassName="flex gap-2.5 items-center"
            onClick={() => setModalShare(true)}
          >
            <GiShare className="text-md" /> Bagikan Pekerjaan
          </RegularButton>
        </FlexBox>
      </div>

      <FlexBox
        className={clsx("text-primary-blue pt-30px pb-60px font-semibold gap-14px", "")}
        align="center"
      >
        <GoClock className="text-xl" />

        <div className="text-sm">
          <div>Diposting {dayjs(created_at).locale("id").fromNow(true)} yang lalu </div>
          <div>
            Lamar pekerjaan ini sebelum tanggal{" "}
            {dayjs(job_expired_at).locale("id").format("DD MMMM YYYY")}
          </div>
        </div>
      </FlexBox>

      <ModalShare
        slug="analytics-consultant"
        onClose={() => setModalShare(false)}
        show={modalShare}
      />
    </section>
  )
}
